;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';
import { ClaudeIcon } from './ClaudeIcon';
import { OpenAiIcon } from './OpenAiIcon';

interface ClientAppIconProps extends React.SVGProps<SVGSVGElement> {
  /** The OAuth client's name, e.g. "Claude" or "ChatGPT". */
  clientName: string | null;
  size?: number;
  /** Rendered when the name matches no known app. */
  fallback?: React.ReactNode;
}

/** Brand mark of an app connected to Native Teams over OAuth, picked by the client's name. */
export function ClientAppIcon({ clientName, fallback = null, ...props }: ClientAppIconProps) {
  const name = clientName?.toLowerCase() ?? '';

  if (name.includes('claude')) {
    return <ClaudeIcon {...props} />;
  }

  if (name.includes('chatgpt') || name.includes('openai')) {
    return <OpenAiIcon {...props} />;
  }

  return <>{fallback}</>;
}
